import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_align_top.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconAlignTop = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlignTop;
